angular.module('lsnBase.deprecated.models')
  .factory('GroupModel', ['LsnGroupModelV1',
    function(LsnGroupModelV1) {
      return LsnGroupModelV1;
    }
  ]);